import { mapParamsBySchema } from '../../../util';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { handleQuerySuccess } from '../../../Hooks/apis/useQuriesSuccess';
import { M_PEA_BASIC_Schema } from './M_PEA_BASIC_Schema';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_PEA_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['PendingApprovals', 'getPeaBasicR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.PendingApprovals.getPeaBasicR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
